<template>
  <div class="businesses-page">

    <!-- ================= HEADER ================= -->
    <div class="page-header">

      <div>
        <h1>Businesses</h1>
        <p>Manage all businesses, subscriptions, and platform activity.</p>
      </div>

      <div class="header-actions">

        <div class="search-box">
          <span class="material-symbols-outlined">search</span>
          <input v-model="searchQuery" placeholder="Search businesses..." />
        </div>


        <button class="ghost-btn">
          <span class="material-symbols-outlined">download</span>
          Export
        </button>

      </div>

    </div>

    <!-- ================= METRICS ================= -->
    
    <div class="metrics-grid">

      <div class="metric-card">
        <span>Total Businesses</span>
        <strong>{{ kpis.total_business }}</strong>
        <small class="positive">Platform Size</small>
      </div>

      <div class="metric-card">
        <span>Active Subscriptions</span>
        <strong>{{ kpis.active }}</strong>
        <small class="positive">Revenue Drivers</small>
      </div>

      <div class="metric-card">
        <span>Trials</span>
        <strong>{{ kpis.trials }}</strong>
        <small class="warning">Monitor</small>
      </div>

      <div class="metric-card">
        <span>Churned</span>
        <strong>{{ kpis.churned }}</strong>
        <small class="danger">Needs Attention</small>
      </div>

    </div>

    <!-- ================= TABLE ================= -->
    <div class="table-card">

      <table>
        <thead>
          <tr>
            <th>Business</th>
            <th>Plan</th>
            <th>Status</th>
            <th>Reviews</th>
            <th>Date</th>
            <!-- <th class="right">Actions</th> -->
          </tr>
        </thead>

        <tbody>

          <tr v-for="biz in filteredBusinesses" :key="biz.buss_id">

        <!-- BUSINESS -->
        <td>
          <div class="business-cell">

            <div class="biz-avatar">
              {{ getInitials(biz.buss_title) }}
            </div>

            <div>
              <div class="biz-name">{{ biz.buss_title }}</div>
              <div class="biz-meta">{{ biz.user_email }}</div>
            </div>

          </div>
        </td>

        <!-- PLAN -->
        <td>
          <span class="plan-badge">
            {{ biz.user_plan_name || "No Plan" }}
          </span>
        </td>

        <!-- STATUS -->
        <td>
          <span :class="['status-pill', biz.user_plan_status]">
            {{ biz.user_plan_status }}
          </span>
        </td>

        <!-- REVIEWS -->
        <td>
          <strong>{{ biz.reviews }}</strong>
        </td>

        <!-- DATE -->
        <td class="muted">
          {{ beautifyDate(biz.buss_datetime) }}
        </td>

        <!-- ACTIONS -->
        <!-- <td class="right">

          <button class="mini-btn" @click="toggleMenu(biz.buss_id)">
            <span class="material-symbols-outlined">more_vert</span>
          </button>

          <div v-if="activeMenu === biz.buss_id" class="actions-menu">

            <div>View</div>
            <div>Billing</div>

            <div
              class="danger"
              @click="suspendBusiness(biz)"
            >
              Suspend
            </div>

          </div>

        </td> -->

      </tr>

        </tbody>
      </table>
<!-- ================= PAGINATION ================= -->

<div class="pagination-bar">

  <button
    class="page-btn"
    :disabled="page === 0"
    @click="prevPage"
  >
    Previous
  </button>

  <span class="page-info">
    Page {{ page + 1 }}
  </span>

  <button
    class="page-btn"
    :disabled="!hasMore"
    @click="nextPage"
  >
    Next
  </button>

</div>
    </div>

  </div>
</template>

<script>
import {
  getBusinessKpiStats,
  getBusinesses,
  updateBusinessStatus
} from "@/apis/adminbusiness";

export default {
  name: "AdminBusinesses",

  data() {
    return {
      searchQuery: "",
      activeMenu: null,

      kpis: {
        total_business: 0,
        active: 0,
        trials: 0,
        churned: 0
      },

      businesses: [],
      page:0
    };
  },

  async mounted() {
    await this.loadPage();
  },

  computed: {
    filteredBusinesses() {
      return this.businesses.filter(b =>
        b.buss_title
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    }
  },

  methods: {
    beautifyDate(datetime) {
        if (!datetime) return "";

        const date = new Date(datetime.replace(" ", "T"));

        return date.toLocaleString("en-IN", {
          day: "numeric",
          month: "short",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit"
        });
      },
    async loadPage() {
      await Promise.all([
        this.loadKpis(),
        this.loadBusinesses()
      ]);
    },

    async loadKpis() {
      const res = await getBusinessKpiStats();
      if (res.status) this.kpis = res.data;
    },

    async loadBusinesses() {
      const res = await getBusinesses(this.searchQuery,this.page);
      if (res.status) this.businesses = res.data;
    },

    toggleMenu(id) {
      this.activeMenu = this.activeMenu === id ? null : id;
    },

    async suspendBusiness(biz) {

      const res = await updateBusinessStatus(
        biz.buss_user,
        "paused"
      );

      if (res.status) {
        biz.user_plan_status = "paused";
        this.activeMenu = null;
      }
    },

    getInitials(name) {
      return name
        .split(" ")
        .map(w => w[0])
        .join("")
        .substring(0, 2)
        .toUpperCase();
    }
  }
};
</script>
<style scoped>

/* ================= PAGE ================= */

.businesses-page {
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: #f6f7f8;
  min-height: 100vh;
}

/* ================= HEADER ================= */

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.page-header h1 {
  font-size: 28px;
  font-weight: 800;
  color: #0f172a;
}

.page-header p {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

/* ================= HEADER ACTIONS ================= */

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* ================= SEARCH ================= */

.search-box {
  height: 40px;
  background: white;
  border-radius: 12px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
  min-width: 240px;
}

.search-box span {
  font-size: 18px;
  color: #94a3b8;
}

.search-box input {
  border: none;
  outline: none;
  font-size: 13px;
  width: 100%;
}

/* ================= BUTTON SYSTEM ================= */

.primary-btn {
  height: 40px;
  padding: 0 16px;
  background: #197fe6;
  border-radius: 12px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: 0.15s;
  white-space: nowrap;
}

.primary-btn:hover {
  background: #166fd1;
}

.ghost-btn {
  height: 40px;
  padding: 0 14px;
  background: white;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: 0.15s;
  white-space: nowrap;
}

.ghost-btn:hover {
  background: #f8fafc;
}

/* ================= METRICS ================= */

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.metric-card {
  background: white;
  border-radius: 16px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 6px 18px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.metric-card span {
  font-size: 12px;
  color: #64748b;
}

.metric-card strong {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.metric-card small {
  font-size: 11px;
}

/* ================= TABLE CARD ================= */

.table-card {
  background: white;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  overflow-x: auto;
  box-shadow: 0 10px 30px rgba(0,0,0,0.04);
  position: relative;
}

/* ================= TABLE ================= */

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
}

thead {
  background: #f8fafc;
}

th {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 700;
  color: #94a3b8;
  padding: 14px 18px;
  text-align: left;
}

td {
  padding: 16px 18px;
  border-top: 1px solid #f1f5f9;
  font-size: 13px;
  color: #0f172a;
  vertical-align: middle;
}

tbody tr:hover {
  background: #f8fafc;
}

/* ================= BUSINESS CELL ================= */

.business-cell {
  display: flex;
  gap: 10px;
  align-items: center;
  min-width: 0;
}

.biz-avatar {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: #197fe6;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.biz-name {
  font-weight: 600;
  font-size: 13px;
}

.biz-meta {
  font-size: 12px;
  color: #94a3b8;
}

/* ================= BADGES ================= */

.plan-badge {
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.plan-badge.pro {
  background: #eef2ff;
  color: #4f46e5;
}

.plan-badge.starter {
  background: #f1f5f9;
  color: #64748b;
}

/* ================= STATUS ================= */

.status-pill {
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.status-pill.active {
  background: #dcfce7;
  color: #166534;
}

.status-pill.trial {
  background: #fef9c3;
  color: #854d0e;
}

.status-pill.paused {
  background: #f1f5f9;
  color: #64748b;
}

/* ================= USAGE ================= */

.usage-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.usage-bar {
  height: 6px;
  background: #e2e8f0;
  border-radius: 20px;
  overflow: hidden;
}

.usage-bar div {
  height: 100%;
  background: #197fe6;
  border-radius: 20px;
}

.usage-wrapper small {
  font-size: 11px;
  color: #64748b;
}

/* ================= ACTION BUTTON ================= */

.mini-btn {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.15s;
}

.mini-btn span {
  font-size: 18px;
  color: #64748b;
}

.mini-btn:hover {
  background: #f1f5f9;
}

/* ================= ACTION MENU ================= */

.actions-menu {
  position: absolute;
  top: 60%;
  right: 18px;
  transform: translateY(-10%);
  background: white;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
  width: 170px;
  padding: 6px;
  z-index: 20;
  animation: fadeIn 0.15s ease;
}

.actions-menu div {
  padding: 9px 10px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border-radius: 8px;
  font-weight: 500;
}

.actions-menu div:hover {
  background: #f1f5f9;
}

.actions-menu .danger {
  color: #ef4444;
}

/* ================= TEXT HELPERS ================= */

.muted {
  font-size: 12px;
  color: #94a3b8;
}

.right {
  text-align: right;
}

.positive { color: #16a34a; }
.warning { color: #f59e0b; }
.danger { color: #ef4444; }

/* ================= ANIMATION ================= */

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: none; }
}

/* ================= MOBILE ================= */

@media (max-width: 768px) {

  .businesses-page {
    padding: 16px;
  }

  .metrics-grid {
    grid-template-columns: 1fr;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .header-actions {
    width: 100%;
  }

  .search-box {
    width: 100%;
    min-width: unset;
  }

  .ghost-btn,
  .primary-btn {
    flex: 1;
    justify-content: center;
  }

}
/* ================= MODAL OVERLAY ================= */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

/* ================= MODAL ================= */

.add-business-modal {
  width: 440px;
  max-width: 95%;
  background: white;
  border-radius: 18px;
  padding: 22px;
  box-shadow: 0 25px 60px rgba(0,0,0,0.18);
  animation: modalEnter 0.18s ease;
}

/* ================= HEADER ================= */

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.modal-header h3 {
  font-size: 18px;
  font-weight: 700;
}

/* ================= CLOSE ================= */

.close-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.close-btn span {
  font-size: 18px;
  color: #64748b;
}

.close-btn:hover {
  background: #e2e8f0;
}

/* ================= BODY ================= */

.modal-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ================= FORM ================= */

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.form-group input,
.form-group select {
  height: 42px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 12px;
  font-size: 13px;
  outline: none;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #197fe6;
  box-shadow: 0 0 0 3px rgba(25,127,230,0.12);
}

/* ================= ACTIONS ================= */

.modal-actions {
  margin-top: 6px;
  display: flex;
  gap: 8px;
}

.modal-actions button {
  flex: 1;
}

/* ================= ANIMATION ================= */

@keyframes modalEnter {
  from { transform: translateY(6px) scale(0.98); opacity: 0; }
  to { transform: none; opacity: 1; }
}

/* ================= MOBILE ================= */

@media(max-width:640px) {

  .add-business-modal {
    width: 100%;
    border-radius: 16px;
  }

  .modal-actions {
    flex-direction: column;
  }
}
.form-group select {
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #94a3b8 50%),
                    linear-gradient(135deg, #94a3b8 50%, transparent 50%);
  background-position: calc(100% - 18px) calc(50% - 3px),
                       calc(100% - 12px) calc(50% - 3px);
  background-size: 6px 6px, 6px 6px;
  background-repeat: no-repeat;
}
/* ================= PAGINATION ================= */

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.04);
}

/* Page Buttons */

.page-btn {
  height: 32px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: white;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
}

.page-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5f5;
  color: #197fe6;
}

/* Disabled State */

.page-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  background: #f1f5f9;
}

/* Page Info */

.page-info {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  padding: 0 6px;
}

/* ================= MOBILE ================= */

@media (max-width: 768px) {

  .pagination-bar {
    justify-content: center;
    width: 100%;
  }

  .page-btn {
    flex: 1;
  }

}
</style>

